import api from './api';

export const credentialsService = {
  /**
   * List all credentials (no sensitive data)
   */
  listCredentials: async () => {
    const response = await api.get('/credentials');
    return response.data.data;
  },

  /**
   * Add new credential
   */
  addCredential: async (credentialData) => {
    const response = await api.post('/credentials', {
      service_name: credentialData.serviceName,
      service_url: credentialData.serviceUrl,
      username: credentialData.username,
      password: credentialData.password,
      metadata: credentialData.metadata
    });
    return response.data.data;
  },

  /**
   * Update credential
   */
  updateCredential: async (credentialId, updates) => {
    const response = await api.patch(`/credentials/${credentialId}`, updates);
    return response.data.data;
  },

  /**
   * Delete credential
   */
  deleteCredential: async (credentialId) => {
    const response = await api.delete(`/credentials/${credentialId}`);
    return response.data;
  },

  /**
   * Get credential access audit log
   */
  getAuditLog: async (filters = {}) => {
    const params = {
      page: filters.page || 1,
      per_page: filters.perPage || 50,
      service_name: filters.serviceName || undefined
    };

    const response = await api.get('/credentials/access-log', { params });
    return response.data;
  }
};
